module.exports = __webpack_public_path__ + "img/SZ.241018fb.png";